const taxRateByState = {
    AL: 0.43,
    AK: 1.21,
    AS: 0, //American Samoa
    AZ: 0.84,
    AR: 0.62,
    CA: 0.81,
    CO: 0.62,
    CT: 1.91,
    DE: 0.53,
    DC: 0.57,
    FM: 0, //Federated States Of Micronesia
    FL: 1.1,
    GA: 0.96,
    GU: 0, //Guam
    HI: 0.28,
    ID: 0.77,
    IL: 2.25,
    IN: 0.88,
    IA: 1.47,
    KS: 1.41,
    KY: 0.84,
    LA: 0.48,
    ME: 1.27,
    MH: 0, //Marshall Islands
    MD: 1.08,
    MA: 1.18,
    MI: 1.83,
    MN: 1.19,
    MS: 0.78,
    MO: 1.0,
    MT: 0.87,
    NE: 1.88,
    NV: 0.92,
    NH: 2.1,
    NJ: 2.29,
    NM: 0.72,
    NY: 1.58,
    NC: 0.85,
    ND: 1.22,
    MP: 0, //Northern Mariana Islands,
    OH: 1.55,
    OK: 0.87,
    OR: 1.08,
    PW: 0, //Palau
    PA: 1.51,
    PR: 0, //Puerto Rico
    RI: 1.61,
    SC: 0.57,
    SD: 1.36,
    TN: 0.75,
    TX: 1.93,
    UT: 0.69,
    VT: 1.72,
    VI: 0, //Virgin Islands
    VA: 0.8,
    WA: 1.08,
    WV: 0.59,
    WI: 1.97,
    WY: 0.62,
};

function getPMI(loanRate, loanYear) {
    if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 30) {
        return 0.0062;
    }
    if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 20) {
        return 0.005867;
    }
    if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 15) {
        return 0.0057;
    }
    if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 30) {
        return 0.0044;
    }
    if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 20) {
        return 0.004067;
    }
    if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 15) {
        return 0.0039;
    }
    if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 30) {
        return 0.0027;
    }
    if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 20) {
        return 0.002367;
    }
    if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 15) {
        return 0.0022;
    }
    return 0;
}

function getPropertyTaxRate(state) {
    return taxRateByState[state]/100 || 0;
}

function checkData({ state, interest, downpayment, homeInsurance, loanYear, hoafee }) {
    return {
        homeInsurance: homeInsurance || 0,
        loanYear: loanYear || 30,
        interest: interest || 0.0581,
        downpayment: downpayment || 0.2,
        hoafee: hoafee || 0,
        state: state || 'CA',
    };
}

function getBaseInfo({ total, state, interest, downpayment, homeInsurance, loanYear, hoafee }) {
    const interestRate = interest; //Interest Rate
    const downpayRate = downpayment;
    const hoaPerMonth = hoafee; //HOA fees
    const propertyTaxRate = getPropertyTaxRate(state);
    const loanMonth = loanYear * 12; //Terms (mth)
    const interestMonthRate = interestRate / 12; //Monthly Interest Rate
    const loanRate = 1 - downpayRate; //LTV(loan to value ratio)
    const PMI = downpayRate >= 0.2 ? 0 : getPMI(loanRate, loanYear); //PMI Private mortgage insurance, downpayment > 20% , could wavie the fee
    let totalInsurance = homeInsurance ? homeInsurance : total ? (total / 2000) * 3.5 : 0;
    const homeInsurancePerMonth = totalInsurance / 12;
    const _l = Math.pow(1 + interestMonthRate, loanMonth);
    return {
        hoaPerMonth,
        propertyTaxRate,
        interestRate,
        interestMonthRate,
        loanRate,
        PMI,
        _l,
        homeInsurance: totalInsurance,
        homeInsurancePerMonth,
    };
}

function _getMonthPayByTotal(data) {
    const totalPrice = data.total;
    const { hoaPerMonth, propertyTaxRate,interestRate, interestMonthRate, PMI, loanRate, _l, homeInsurance, homeInsurancePerMonth } = getBaseInfo(data);
    //calculations
    const loanAmount = totalPrice * loanRate; //Loan Amount
    const taxAnnualAmount = propertyTaxRate * totalPrice; //Annual Property Tax
    const pmiAnnualFee = PMI * loanAmount; //Annual Private Mortgage

    const loanPerMonth = (loanAmount * (interestMonthRate * _l)) / (_l - 1); //Loan/mth
    const taxPerMonth = taxAnnualAmount / 12; //Property Tax/mth
    const pmiPerMonth = pmiAnnualFee / 12; //Private Mortgage Insurance/mth
    const monthTotal = loanPerMonth + taxPerMonth + hoaPerMonth + homeInsurancePerMonth + pmiPerMonth;
    // return Math.round(monthTotal);

    return {
        ltv: Math.round(loanRate),
        downpayment: totalPrice * (1-loanRate),
        loanAmount: Math.round(loanAmount),
        loanPerMonth: Math.round(loanPerMonth),
        interestRate: interestRate,
        taxRate: propertyTaxRate,
        taxPerMonth: Math.round(taxPerMonth),
        hoaPerMonth: Math.round(hoaPerMonth),
        pmiPerMonth: Math.round(pmiPerMonth),
        homeInsurancePerMonth: Math.round(homeInsurancePerMonth),
        monthTotal: Math.round(monthTotal),
    };
}

function _getTotalByMonthPay(data) {
    const monthTotal = data.monthPay;
    const { hoaPerMonth, propertyTaxRate, interestMonthRate, PMI, loanRate, _l, homeInsurancePerMonth } = getBaseInfo(data);
    //calculations
    const loanPerMonthRate = (loanRate * interestMonthRate * _l) / (_l - 1);
    const _y = (propertyTaxRate - PMI * loanRate) / 12 / loanPerMonthRate;
    const totalPrice = (monthTotal / loanPerMonthRate - hoaPerMonth / loanPerMonthRate - homeInsurancePerMonth / loanPerMonthRate) / (1 + _y);
    return Math.round(totalPrice);
}

export default {
    getMonthPayByTotal(data) {
        if (!data.total) {
            return null;
        }
        Object.assign(data, checkData(data));
        return _getMonthPayByTotal(data);
    },
    getTotalByMonthPay(data) {
        if (!data.monthPay) {
            return null;
        }
        Object.assign(data, checkData(data));
        return _getTotalByMonthPay(data);
    },
};
